import React, { memo, MouseEvent, useState, useEffect, useRef } from 'react'
import styled, { useTheme } from 'styled-components'
import ContextMenu, { Functionality } from './contextMenu'

const Wrapper = styled.div`
  position: relative;

  a {
    cursor: pointer;
  }
`

export interface MenuButtonProps extends React.HTMLAttributes<HTMLAnchorElement> {
  functionalities: Functionality[]
  xBasis: 'left' | 'right'
  yBasis: 'top' | 'bottom'
  xBasisOffset?: number
  yBasisOffset?: number
  button?: React.ReactNode
}

function ContextMenuButton({
  functionalities,
  xBasis,
  yBasis,
  xBasisOffset = 0,
  yBasisOffset = 0,
  button,
  ...props
}: MenuButtonProps) {
  const [isVisible, setIsVisible] = useState(false)

  const theme = useTheme()

  const radius = 3
  const padding = 4
  const width = 30
  const height = 30

  return (
    <Wrapper>
      {button ? (
        <div
          onClick={(event: MouseEvent<HTMLDivElement>) => {
            event.preventDefault()
            setIsVisible(true)
          }}
        >
          {button}
        </div>
      ) : (
        <a
          href='javascript:;'
          onClick={event => {
            event.preventDefault()
            setIsVisible(true)
          }}
          {...props}
        >
          <svg width={width} height={height}>
            <g fill='#999'>
              <circle r={radius} cx={width / 2} cy={padding} />
              <circle r={radius} cx={width / 2} cy={padding + (height - padding * 2) * 0.5} />
              <circle r={radius} cx={width / 2} cy={padding + (height - padding * 2)} />
            </g>
          </svg>
        </a>
      )}

      {isVisible ? (
        <ContextMenu
          functionalities={functionalities}
          xBasis={xBasis}
          yBasis={yBasis}
          xBasisOffset={xBasisOffset}
          yBasisOffset={yBasisOffset}
          onExit={() => setIsVisible(false)}
        />
      ) : null}
    </Wrapper>
  )
}
export default memo(ContextMenuButton)
